export * from './solar-terms.component';
